import DefaultInput from '@/components/inputs/DefaultInput/DefaultInput'
import { CartRowModel } from '@/types/api'
import usePrice from '@/utils/hooks/usePrice'
import React from 'react'
import CartRow, { ColumnSettings } from '../CartRow/CartRow'
import QuantityInput from '@/components/inputs/QuantityInput/QuantityInput'
import useCartRow from '@/utils/hooks/useCartRow'
import { useTranslation } from 'next-i18next'
import CartItemSettings from '../CartItemSettings/CartItemSettings'
import CartTyre from '../CartTyre/CartTyre'
import CarModel from '../CarModel/CarModel'
import Image from 'next/image'
import Link from 'next/link'
import WheelPackage from '../WheelPackage/WheelPackage'
import useLocalizedLink from '@/utils/hooks/useLocalizedLink'
import StockStatus from '@/components/article/StockStatus/StockStatus'

type Props = {
  item: CartRowModel
}

const CartImage = ({ item }: Props) => {
  if (!item.imageId) return null

  return (
    <Image
      src={`${process.env.NEXT_PUBLIC_API}/images/${item.imageId}`}
      style={{ objectFit: 'contain' }}
      width={50}
      height={50}
      alt={item.articleText}
    />
  )
}

const CartItem = (props: Props) => {
  const { t } = useTranslation(['cart', 'common'])
  const { price } = usePrice()
  const {
    remove,
    updateQuantity,
    updateReference
  } = useCartRow(props.item)
  const getLocalizedLink = useLocalizedLink()

  let productLink = getLocalizedLink(props.item.productLink)

  const columns: ColumnSettings[] = [
    {
      label: '',
      value: <Link href={productLink}><CartImage item={props.item} /></Link>,
    },
    {
      label: t('common:articleNumber') || '',
      value: <Link href={productLink}>{props.item.articleId}</Link>,
    },
    {
      label: t('common:articleText') || '',
      value: <div><Link href={productLink}>{props.item.articleText}</Link><StockStatus
        article={props.item}
        light={true}
      /></div>,
    },  
    {
      label: t('common:reference') || '',
      value: (
        <DefaultInput
          name='reference'
          searchIcon={false}
          tiny={true}
          value={props.item.reference}
          onBlur={updateReference}
        />
      ),
    },
    {
      label: t('common:price') || '',
      value: price(props.item.price),
      textAlign: 'right',
    },
    {
      label: t('common:quantity') || '',
      textAlign: 'center',
      value: (
        <QuantityInput
          value={props.item.quantity}
          onChange={updateQuantity}
        />
      ),
    },
    {
      label: t('cart:total') || '',
      value: price(props.item.price * props.item.quantity, true),
      textAlign: 'right',
    },
  ]

  return (
    <div>
      <CartRow
        columns={columns}
        showRemoveButton={true}
        onClickRemove={remove} 
      >
        <>
          <CarModel
            licensePlate={props.item.licensePlate}
            carModel={props.item.carModel}
          />
          <WheelPackage
            item={props.item}
          />
          <CartTyre
            item={props.item}
          />
          <CartItemSettings
            item={props.item}
          />
        </>
      </CartRow>
    </div>
  )
}

export default CartItem